// extracted by mini-css-extract-plugin
export default {"contactus-form__wrapper":"wM1hD8","contactus-form__right":"wgVf9b","contactus-form__title":"GWT6jh","contactus-form__subtext":"mHzdgl"};